
function isObjectNotEmpty(obj) {
    return (obj != null && typeof(obj) === 'object' && Object.keys(obj).length > 0);
}

function isStringEmpty(str) {
    return !(typeof str === "string" && str.trim() !== "");
}

function parseStringOr(str, def) {
    if (undefined === def) {
        throw new Error('Function parseStringOr: Default value is required!');
    }

    str = (undefined === str || str == null) ? "" : String(str).trim();

    return (str === "") ? def : str;
}

/**
 * Formats acepting as boolean:
 *     - boolean
 *     - String(insensitive case)
 *     - Interger 1 and 0
 */
function parseBoolOr(bool, def) {
    if (undefined === def) {
        throw new Error('Function parseBoolOr: Default value is required!');
    }

    bool = String(bool).trim().toLowerCase();

    switch (bool) {
        case '1':
        case 'true':
            bool = true;
            break;

        case '0':
        case 'false':
            bool = false;
            break;

        default:
            bool = def;
            break;
    }

    return bool;
}


function parseJsonOr(json, def) {
    if (undefined === def) {
        throw new Error('Function parseJsonOr: Default value is required!');
    }

    try {
        let type = typeof json;

        while (type === 'string') {
            json = JSON.parse(json);
            type = typeof json;
        }

        if (type !== 'object') {
            throw new Error('Function parseJsonOr: It is not an object;')
        }
    }
    catch (e) {
        console.log('Function parseJsonOr: Error parsing JSON:', json);
        json = def;
    }

    return json;
}

function moneyFormat(price, currency) {
    price = parseFloat(price) || 0;
    currency = parseStringOr(currency, 'CAD');
    let locale = "";

    switch (currency) {
        case 'USD':
            locale = 'en-US';
            break;

        default:
            currency = 'CAD';
            locale = 'fr-CA';
            break;
    }

    let formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
    });

    return formatter.format(price);
}

function ucfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function createFormattedAddress(params) {
    let suite = parseStringOr(params.suite, "");
    let civic = parseStringOr(params.civic, "");
    let street = parseStringOr(params.street, "");
    let city = parseStringOr(params.city, "");
    let state = parseStringOr(params.state, "");
    let country = parseStringOr(params.country, "");
    let zip = parseStringOr(params.zip, "");
    let formattedAddress = "";

    if (civic !== "") {
        if (suite !== "") {
            formattedAddress += suite + "/";
        }

        formattedAddress += civic + " ";
    }

    if (street !== "") {
        formattedAddress += street + ", ";
    }

    if (city !== "") {
        formattedAddress += city + " ";
    }

    if (state !== "") {
        formattedAddress += state + " ";
    }

    if (zip !== "") {
        formattedAddress += zip + " ";
    }

    formattedAddress = formattedAddress.trim();

    if (country !== "") {
        formattedAddress += ", " + country;
    }

    return formattedAddress;
}

export function getURL(url) {
    let parsedUrl;

    if (url) {
        parsedUrl = parseStringOr(url, "");
    }
    else {
        parsedUrl = parseStringOr(window.location.href, "");
    }

    if (parsedUrl !== "") {
        parsedUrl = parsedUrl
            .replace("#/", "/")
            .replace("//", "/");

        try {
            return new URL(parsedUrl);
        }
        catch (err) {
            console.error(err);
        }
    }

    return null;
}

export {
    isObjectNotEmpty,
    isStringEmpty,
    parseBoolOr,
    parseJsonOr,
    parseStringOr,
    createFormattedAddress,
    moneyFormat,
    ucfirst,
}
